import React from 'react'
import { string, func } from 'prop-types'
import { css } from '@emotion/react'

import CloseIcon from '@/assets/icons/close.inline.svg'
import { PRODUCT } from '@/utils'

const badgeCss = (theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 1px 4px 1px 8px;
  height: 24px;
  background-color: ${theme.colors.blue100};
  border-radius: 4px;

  &.filter-badge.filter-badge > span {
    display: block;
    font-size: 15px;
    line-height: 22px;
    color: ${theme.colors.blue800};
    opacity: 1;
  }

  div {
    height: 100%;

    svg {
      cursor: pointer;
      top: 1px;
      fill: ${theme.colors.secondary};
      height: 16px;
      width: 16px;
    }
  }
`

const FilterBadge = ({ selected = PRODUCT.LiveChat, onClose }) => (
  <div css={badgeCss} className="filter-badge">
    <span>{selected}</span>
    <div onClick={onClose}>
      <CloseIcon />
    </div>
  </div>
)

FilterBadge.propTypes = {
  selected: string,
  onClose: func,
}

export default FilterBadge
